<template>
  <div class="share-item-list">
    <ul>
      <li v-for="item in showList" :key="item.id + '-' + item.type">
        <v-icon class="del-ico" name="del" @click="delItem(item)" />
        <org-item :option="item">
          <span slot="text">{{ item.name }}</span>
        </org-item>
      </li>
    </ul>
    <div class="add-btn">
      <vm-select-business-popper v-if="visible" :key="vmSelectKey" :config="selectorConfig" @submit="onVmSelectSubmit"
        @visibleChange="visibleChange"
>
        <v-button type="link" kind="primary">
          <v-icon name="basic_new_line" />
          添加
        </v-button>
      </vm-select-business-popper>
      <!-- <org-select
                :single="false"
                :depart-can-select="true"
                :selected="selectedList"
                :his-selected="hisSelectedList"
                @confirm="onSelectConfirm"
                mode="pop"
                title-selected="已选员工/部门"
                subtitle="选择员工/部门"
            >
                <a
                    slot="trigger"
                    href="javascript:;"
                >添加</a>
            </org-select> -->
    </div>
  </div>
</template>

<script>
import { Icon } from 'vhtml-ui';
import OrgItem from '@/components/org-item';
// import OrgSelect from 'src/components/org-select';
import VmSelectBusinessPopper from '@/components/vm-select-business-popper';

const req = require.context('./assets/icons', false, /[^.]+\.svg$/);
Icon.addSprites(req);

export default {
  components: {
    OrgItem,
    // OrgSelect,
    VmSelectBusinessPopper,
  },

  props: {
    options: {
      type: Array,
      default: () => [],
    },
  },

  data() {
    const selectedList = this.showList || [];

    return {
      visible: true,
      cloading: false,
      allowSearchTxt: '',
      originList: this.options || [],
      selectedList,
      hisSelectedList: [],
      vmSelectKey: `vsk${Date.now()}`,
      // selectorConfig: {},
    };
  },

  computed: {
    selectorConfig() {
      return {
        tabs: {
          // 同事数据源标识
          colleague: {
            folderCanSelect: true,
            selected: this.showList || [], // 默认已选id
            checkStrictly: true, // 严格模式，父子不相关
          },
        },
        multiple: true, // 多选/单选
        maxLength: 0, // 最大可选数 ，0 表示不限制,
        layout: {
          search: true, // 是否展示搜索，默认true
          list: true, // 是否展示列表 默认true
          status: true, // 是否展示已选数。默认 true
          // 是否展示 全选 “确认/取消” 。默认 true
          action: {
            selectAll: false,
            btn: true,
          },
          selected: true, // 是否展示已选列表， 默认true
        },
        withCheckbox: false, // 是否展示checkbox
      };
    },
    showList() {
      return this.transOriginToSelect(this.originList)
        .sort((itemA, itemB) => (itemA.isFolder && !itemB.isFolder ? -1 : 0));
    },
  },

  watch: {
    options(arr) {
      this.originList = arr || [];
      this.selectedList = this.showList || [];
      this.selectorConfig.tabs.colleague.selected = this.showList || [];
    },
  },

  created() {
    this.originList = this.options || [];
    this.selectedList = this.showList || [];
  },

  methods: {
    visibleChange(visible) {
      // 刷新组件配置数据，用于重置上一次的选项
      if (!visible) {
        this.visible = false;
        setTimeout(() => {
          this.visible = true;
        });
      }
    },
    onVmSelectSubmit(data) {
      const { colleague } = data || {};
      this.onSelectConfirm(colleague);
    },

    delItem(item) {
      const { id } = item || {};
      const index = this.originList.findIndex(oItem => oItem.id === id);

      if (index > -1) {
        this.originList.splice(index, 1);
      }

      // selected不是双向绑定，重新渲染选择器组件来更新selected值
      this.vmSelectKey = `vsk${Date.now()}`;
    },

    onSelectConfirm(list) {
      this.originList = list.map((item) => {
        const { id, name, gender, isFolder, isParent } = item || {};

        let type = 1;

        if (isFolder || isParent) {
          type = 2;
        }

        return {
          id,
          type,
          detail: JSON.stringify({
            name,
            gender,
          }),
        };
      });
      this.$emit('change', this.originList);
    },

    formatItem(item) {
      const { id, type, name, gender } = item || {};
      let isFolder = false;

      if (parseInt(type, 10) === 2) {
        isFolder = true;
      }

      return {
        id,
        name,
        gender: parseInt(gender, 10),
        isFolder,
      };
    },

    transOriginToSelect(list) {
      return list.map((item) => {
        const { id, type, detail } = item || {};
        let detailObj = {};

        try {
          detailObj = JSON.parse(detail);
        } catch (e) {
          detailObj = {};
        }

        const { name, account, gender } = detailObj;

        let formatName = name;
        let isFolder = false;

        if (account) {
          formatName = `${name}(${account})`;
        }

        if (parseInt(type, 10) === 2) {
          isFolder = true;
        }

        return {
          id,
          name: formatName,
          isFolder,
          gender,
        };
      });
    },

    transSelectToOrigin(list) {
      return list.map((item) => {
        const { id, name, gender, isFolder } = item || {};

        let type = 1;

        if (isFolder) {
          type = 2;
        }

        return {
          id,
          type,
          detail: JSON.stringify({
            name,
            gender,
          }),
        };
      });
    },
  },
};
</script>

<style lang="less">
@import './index.less';
</style>
